import React, { useState } from "react";

const TreatmentModal = ({ isOpen, onClose, onSave, parents = [] }) => {
  const [selectedParents, setSelectedParents] = useState([]);
  const [noParentAttended, setNoParentAttended] = useState(false);
  const [manualParentName, setManualParentName] = useState("");
  const [useManualEntry, setUseManualEntry] = useState(false);

  // Validation: At least one attendance option must be selected
  const isAttendanceSelected = noParentAttended ||
                                 (useManualEntry && manualParentName.trim()) ||
                                 selectedParents.length > 0;

  const handleSave = () => {
    const attendanceData = {
      selectedParents: selectedParents || [],
      billingParents: [],
      noParentAttended,
      manualParentName: useManualEntry ? manualParentName.trim() : ""
    };
    onSave(attendanceData.selectedParents, attendanceData.billingParents, attendanceData);
    onClose();
  };

  const handleSkip = () => {
    onSave([], [], { selectedParents: [], billingParents: [], noParentAttended: false, manualParentName: "" });
    onClose();
  };

  const handleNoParentAttendedChange = (checked) => {
    setNoParentAttended(checked);
    if (checked) {
      setSelectedParents([]);
      setUseManualEntry(false);
      setManualParentName("");
    }
  };

  const handleManualEntryChange = (checked) => {
    setUseManualEntry(checked);
    if (checked) {
      setSelectedParents([]);
      setNoParentAttended(false);
    } else {
      setManualParentName("");
    }
  };

  return isOpen ? (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
      <div className="bg-white rounded-sm shadow-lg w-full max-w-3xl p-6">
        {/* Modal Header */}
        <div className="flex justify-between items-center border-b pb-4">
          <h2 className="text-lg font-semibold text-gray-900">
            Attendance
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600">
            ✕
          </button>
        </div>

        {/* Warning Box */}
        <div className="mt-6 p-4 bg-yellow-50 border border-yellow-300 rounded-sm">
          <p className="text-sm text-yellow-800">
            <strong>⚠️ Warning:</strong> Parent/Guardian must be present for at least 40% of session to split
          </p>
        </div>

        {/* Attendance Controls */}
        <div className="mt-6">
          <h3 className="text-sm font-semibold text-gray-900 mb-2">
            Select Attendance
          </h3>
          <div className="border rounded-sm p-3 bg-gray-50 space-y-3">
            {/* No Parent Attended Option */}
            <label className="flex items-center space-x-2 pb-2 border-b border-gray-300">
              <input
                type="checkbox"
                checked={noParentAttended}
                onChange={(e) => handleNoParentAttendedChange(e.target.checked)}
                className="h-4 w-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
              />
              <span className="text-sm font-semibold text-red-600">
                No Parent Attended
              </span>
            </label>

            {/* Manual Entry Option */}
            <div className="pb-2 border-b border-gray-300">
              <label className="flex items-center space-x-2 mb-2">
                <input
                  type="checkbox"
                  checked={useManualEntry}
                  onChange={(e) => handleManualEntryChange(e.target.checked)}
                  className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
                <span className="text-sm font-semibold text-gray-900">
                  Other Parent/Guardian (Manual Entry)
                </span>
              </label>
              {useManualEntry && (
                <input
                  type="text"
                  value={manualParentName}
                  onChange={(e) => setManualParentName(e.target.value)}
                  placeholder="Enter parent/guardian name"
                  className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-indigo-500 focus:border-indigo-500"
                />
              )}
            </div>

            {/* Linked Parents */}
            {parents && parents.length > 0 ? (
              parents.map((parent) => (
                <label
                  key={parent._id}
                  className="flex items-center space-x-2 mb-1">
                  <input
                    type="checkbox"
                    checked={selectedParents.includes(parent)}
                    onChange={() =>
                      setSelectedParents((prev) =>
                        prev.includes(parent)
                          ? prev.filter((p) => p !== parent)
                          : [...prev, parent]
                      )
                    }
                    disabled={noParentAttended || useManualEntry}
                    className={`h-4 w-4 ${
                      noParentAttended || useManualEntry
                        ? "cursor-not-allowed opacity-50"
                        : "text-indigo-600 border-gray-300 focus:ring-indigo-500"
                    } rounded`}
                  />
                  <span className={`text-sm ${
                    noParentAttended || useManualEntry
                      ? "text-gray-400"
                      : "text-gray-900"
                  }`}>
                    {parent.firstName} {parent.lastName}
                  </span>
                </label>
              ))
            ) : (
              <div className="text-sm text-gray-900">No linked parents found</div>
            )}
          </div>
        </div>

        {/* Modal Actions */}
        <div className="flex justify-end space-x-2 mt-6">
          <button
            className="px-3 py-2 text-sm font-semibold text-gray-700 bg-gray-200 rounded-sm hover:bg-gray-300"
            onClick={onClose}>
            Cancel
          </button>
          <button
            className={`px-3 py-2 text-sm font-semibold text-white rounded-sm ${
              isAttendanceSelected
                ? "bg-indigo-600 hover:bg-indigo-500"
                : "bg-gray-400 cursor-not-allowed"
            }`}
            onClick={handleSave}
            disabled={!isAttendanceSelected}>
            Save
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

export default TreatmentModal;
